import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import UserProfileComponent from '../../components/OnBoarding/UserProfile';
import { createUserProfileRequest, postUserAvatarRequest } from '../../actionCreators/userProfile';
import { getDepartmentsStart } from '../../actionCreators/departmentActions';
import { getUserTagsStart } from '../../actionCreators/userTags';
import { getTasksRequest } from '../../actionCreators/employeeOnboarding';
import { fetchFeatureFlagsRequest } from '../../actionCreators/featureFlags';
import { useNavigate } from 'react-router-dom';

const UserProfile = (props) => {
  const history = useNavigate();
  return <UserProfileComponent props={{ ...props, history }} />;
};

const UserProfileContainer = (props) => {
  const state = useSelector((state) => {
    const featureFlags = state.featureFlags;
    const taskCount = state.employeeOnboard.tasks.length;
    const inProgressTaskCount = state.employeeOnboard.tasks.filter(
      (item) => !item.is_completed,
    ).length;
    const showEmployeeOnboard =
      featureFlags.EMPLOYEE_ONBOARDING && taskCount && inProgressTaskCount;
    return {
      location: state.router.location,
      token: state.currentUser.signInData,
      userData: state.currentUser.userData,
      userTags: state.userTags.data || [],
      departments: state.departments.data || [],
      showEmployeeOnboard,
      customAppId: state.customApp.id,
    };
  });

  const dispatch = useDispatch();

  const actions = {
    createUserProfile: (payload) => dispatch(createUserProfileRequest(payload)),
    postUserAvatar: (payload) => dispatch(postUserAvatarRequest(payload)),
    getDepartments: () => dispatch(getDepartmentsStart()),
    getUserTags: () => dispatch(getUserTagsStart()),
    getEmployeeOnboardingTasks: () => dispatch(getTasksRequest()),
    fetchFeatureFlags: () => dispatch(fetchFeatureFlagsRequest()),
  };

  return <UserProfile {...props} {...state} {...actions} />;
};

export default UserProfileContainer;
